import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const Live = () => {
    const [newsList, setNewsList] = useState([]);
    const API_BASE = "http://localhost:5000/api";

    // --- FETCH NEWS FROM BACKEND ---
    useEffect(() => {
        const fetchNews = async () => {
            try {
                const res = await axios.get(`${API_BASE}/news`);
                setNewsList(res.data);
            } catch (error) {
                console.error("Error fetching news:", error);
            }
        };
        fetchNews();
    }, []);

    // --- STYLES ---
    const mainColor = '#003366';
    const sectionTitleStyle = {
        color: mainColor, 
        borderBottom: `2px solid ${mainColor}`, 
        paddingBottom: '10px', 
        marginBottom: '20px',
        fontSize: '18px', 
        fontFamily: 'serif', 
        textTransform: 'uppercase', 
        fontWeight: 'bold'
    };

    return (
        <div className="container mt-5 mb-5 font-sans">
            <div className="row">
                
                {/* ================= LEFT SIDEBAR ================= */}
                <div className="col-lg-3 mb-4">
                    <h4 style={sectionTitleStyle}>GUVERN</h4>
                    <div className="list-group list-group-flush border-bottom">
                         <Link to="/government" className="list-group-item list-group-item-action text-secondary border-0 ps-0" style={{fontSize:'14px'}}>
                            <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> Cabinetul de Miniștri
                        </Link>
                        <Link to="#" className="list-group-item list-group-item-action text-secondary border-0 ps-0" style={{fontSize:'14px'}}>
                            <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> Ședințe de Guvern
                        </Link>
                        <Link to="#" className="list-group-item list-group-item-action text-secondary border-0 ps-0" style={{fontSize:'14px'}}>
                            <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> Agenda Publică
                        </Link>
                        <Link to="#" className="list-group-item list-group-item-action text-secondary border-0 ps-0" style={{fontSize:'14px'}}>
                            <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> Comunicate de presă
                        </Link>
                    </div>
                </div>

                {/* ================= CENTER CONTENT (LIVE & NEWS) ================= */}
                <div className="col-lg-6 mb-4">
                    
                    {/* 1. LIVE HEADER */}
                    <h4 style={sectionTitleStyle}>LIVE TRANSMISSION</h4>
                    
                    {/* 2. VIDEO PLAYER */}
                    <div className="ratio ratio-16x9 mb-3 shadow-sm border">
                        <iframe 
                            src="https://www.youtube.com/embed/jfKfPfyJRdk?autoplay=1&mute=1" 
                            title="Live Government Broadcast" 
                            allowFullScreen
                        ></iframe>
                    </div>

                    {/* Archive Link */}
                    <div className="mb-5">
                        <a href="https://www.youtube.com/user/GuvernulRepubliciiMoldova" target="_blank" rel="noreferrer" className="text-decoration-underline fw-bold" style={{color: mainColor}}>
                            ARHIVA ÎNREGISTRĂRILOR VIDEO &raquo;
                        </a>
                    </div>

                    {/* 3. LATEST NEWS SECTION */}
                    <h4 style={sectionTitleStyle}>LATEST NEWS</h4>
                    
                    {newsList.length > 0 ? (
                        <div className="d-flex flex-column gap-4">
                            {newsList.map((news) => (
                                <div key={news._id} className="card border-0 shadow-sm">
                                    <div className="row g-0">
                                        <div className="col-md-4">
                                            <img 
                                                src={news.image} 
                                                className="img-fluid rounded-start h-100" 
                                                style={{objectFit: 'cover'}} 
                                                alt={news.title}
                                                onError={(e) => {e.target.src = 'https://via.placeholder.com/150?text=News'}}
                                            />
                                        </div>
                                        <div className="col-md-8">
                                            <div className="card-body py-2">
                                                <h6 className="card-title fw-bold" style={{color: mainColor, fontSize:'15px'}}>
                                                    {news.title}
                                                </h6>
                                                <p className="card-text text-muted mb-2" style={{fontSize: '12px', lineHeight: '1.4'}}>
                                                    {news.description.substring(0, 80)}...
                                                </p>
                                                <p className="card-text"><small className="text-muted" style={{fontSize:'11px'}}>Last updated: Today</small></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="alert alert-light border text-center">
                            No news available at the moment.
                        </div>
                    )}

                </div>

                {/* ================= RIGHT SIDEBAR (CALENDAR) ================= */}
                <div className="col-lg-3">
                    <h4 style={sectionTitleStyle}>AGENDA PUBLICĂ</h4>
                    
                    <div className="bg-white border rounded shadow-sm p-0 mb-4">
                        <div className="d-flex justify-content-between align-items-center text-white p-2" style={{backgroundColor: mainColor}}>
                            <span className="fw-bold" style={{fontSize:'14px'}}>Ianuarie 2026</span>
                            <div>
                                <button className="btn btn-sm btn-link text-white p-0 me-2 text-decoration-none">&laquo;</button>
                                <button className="btn btn-sm btn-link text-white p-0 text-decoration-none">&raquo;</button>
                            </div>
                        </div>
                        <div className="p-2">
                             <table className="table table-sm text-center border-0 mb-0" style={{fontSize: '12px'}}>
                                <thead>
                                    <tr style={{color: mainColor}}>
                                        <th>L</th><th>M</th><th>M</th><th>J</th><th>V</th><th>S</th><th>D</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="text-muted">29</td><td className="text-muted">30</td><td className="text-muted">31</td>
                                        <td className="text-danger fw-bold border border-danger">1</td>
                                        <td className="bg-light fw-bold">2</td><td>3</td><td>4</td>
                                    </tr>
                                    <tr><td>5</td><td>6</td><td>7</td><td>8</td><td>9</td><td>10</td><td>11</td></tr>
                                    <tr><td>12</td><td>13</td><td>14</td><td>15</td><td>16</td><td>17</td><td>18</td></tr>
                                    <tr><td>19</td><td>20</td><td>21</td><td>22</td><td>23</td><td>24</td><td>25</td></tr>
                                    <tr><td>26</td><td>27</td><td>28</td><td>29</td><td>30</td><td>31</td><td className="text-muted">1</td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Live;